export default "__VITE_ASSET__4RZ$b2yP__"